import {
  REQUEST_ORDER_HISTORY,
  RECEIVE_ORDER_HISTORY
} from '../actions/OrderHistoryActions';

function posts(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case REQUEST_ORDER_HISTORY: {
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    }
    case RECEIVE_ORDER_HISTORY: {
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        lastUpdated: action.receivedAt
      });
    }
    default:
      return state;
  }
}

function OrderHistoryReducer(state = {
  items: []
}, action) {
  switch (action.type) {
    case REQUEST_ORDER_HISTORY:
    case RECEIVE_ORDER_HISTORY: {
      return Object.assign({}, state, posts(state, action));
    }
    default: {
      return state;
    }
  }
}

export {
  OrderHistoryReducer
};


// WEBPACK FOOTER //
// ./src/reducers/OrderHistoryReducer.js